<moedas-loading></moedas-loading>

<app-header *ngIf="showHeader"></app-header>
<div [ngClass]="{ 'content--gap-top': showHeader }">
   <router-outlet></router-outlet>
</div>
<app-footer *ngIf="showFooter"></app-footer>
